<template>
    <div>
    <!-- header banner -->
        <div class="headerBanner">
            <div :class="[{'headerText': $vuetify.breakpoint.smAndUp},
                          {'headerTextMob': $vuetify.breakpoint.xsOnly}, 'white--text']">
                ERGEBNISDIENST
            </div>
        </div>
    <!-- admin -->
        <app-admin v-if="1==2"></app-admin>
    <!-- nationale ligen -->
        <div class="text-center pb-10 pt-15">
            <img src="../../assets/wappen/Oesterreich.png" class="elevation-4 pa-3"
                 width="128px" @click="openLandesverband('NationaleLigen')">
            <br>
            <v-btn color="primary" text class='mt-2' @click="openLandesverband('NationaleLigen')">
                <v-icon class="mr-2">mdi-arrow-right</v-icon>Nationale Ligen
            </v-btn>
        </div>
    <!-- landesverbaende -->
        <div class="d-flex flex-wrap justify-center pt-5 pb-3" style="max-width: 700px; margin: auto">
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/BurgenlandFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Burgenland')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Burgenland')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Burgenland
                </v-btn>
            </div>
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/KaerntenFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Kärnten')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Kärnten')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Kärnten
                </v-btn>
            </div>
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/NiederoesterreichFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Niederösterreich')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Niederösterreich')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Niederöst...
                </v-btn>
            </div>
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/OberoesterreichFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Oberösterreich')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Oberösterreich')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Oberöst...
                </v-btn>
            </div>
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/SalzburgFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Salzburg')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Salzburg')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Salzburg
                </v-btn>
            </div>
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/SteiermarkFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Steiermark')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Steiermark')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Steiermark
                </v-btn>
            </div>
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/TirolFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Tirol')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Tirol')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Tirol
                </v-btn>
            </div>
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/VorarlbergFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Vorarlberg')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Vorarlberg')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Vorarlberg
                </v-btn>
            </div>
            <div class="text-center mx-3 lvBox mb-7">
                <img src="../../assets/wappen/WienFlag.png" class="flag elevation-4"
                     @click="openLandesverband('Wien')">
                <v-btn text color="red" large class='mt-2' @click="openLandesverband('Wien')">
                    <v-icon class="mr-2">mdi-arrow-right</v-icon>Wien
                </v-btn>
            </div>
        </div>
        <div class="text-center mb-10">
            <v-btn color="primary" @click="openLiveSpiele()">
                <v-icon class="mr-2">mdi-arrow-right</v-icon>
                Zu den Live-Spielen
            </v-btn>
        </div>
        <div v-if="user.permissions.pass || user.permissions.classic || user.permissions.bowling"
             class="text-center mb-10">
            <v-btn color="primary" @click="openMitgliederverwaltung()">
                <v-icon class="mr-2">mdi-arrow-right</v-icon>Zur Mitgliederverwaltung
            </v-btn>
        </div>
    <!-- footer -->
        <div class="grey lighten-3 pb-15">
            <v-container class="text-center">
                <v-row no gutters class="font-weight-bold heebo">
                    <v-col md="4" cols="12">
                        <div class="my-10">Ausrüster</div>
                        <img src="../../assets/sponsorLogos/Puma_Logo.png" width="180px">
                    </v-col>
                    <v-col md="4" cols="12">
                        <div class="my-10">Sponsoren</div>
                        <img src="../../assets/sponsorLogos/Bundes-Sport-GmbH-quer-RGB.png"
                             width="180px" class="mb-5"><br>
                        <img src="../../assets/sponsorLogos/Sport_Austria_Logo_vektor.png"
                             width="180px" class="mb-5"><br>
                        <img src="../../assets/sponsorLogos/BMKOES_Logo_cmyk.png"
                             width="200px" class="mb-5"></v-col>
                    <v-col md="4" cols="12">
                        <div class="my-10">Anschrift</div>
                        <div class="body-2 grey--text text--darken-1">
                            <div>Österreichischer Sportkegel und Bowlingverband</div>
                            <div>Huglgasse 13-15 / 2 / 2 / 6</div>
                            <div>A – 1150 Wien</div>
                            <div>T +43 1 982 1802</div>
                            <div>M +43 660 598 27 21</div>
                            <div>Mail: office@oeskb-kegeln-bowling.at</div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
    <!-- impressum -->
        <div class="grey--text text--lighten-2 caption black text-center py-10 px-5">
            © 2021 ÖSKB - Österreichischer Sportkegel- und Bowlingverband |
            <a href="https://www.oeskb.at/classic/impressum/"
               class="impressum">Impressum</a>
             |
            <a href="https://www.oeskb.at/classic/impressum/"
               class="impressum">Datenschutzerklärung</a>
            | site by <a href="https://www.numberone.solutions" target="_blank"
                         class="impressum">Number One Solutions Gmbh</a> | V {{version}}
        </div>

    </div>
</template>

<script>
    import AppAdmin from "../../AppAdmin";

    export default {
        components: {AppAdmin},
        name: "region-selection",
        computed: {
            user(){ return this.$store.state.user },
            version(){ return localStorage.getItem("Version") }
        },
        methods: {
            openLandesverband(id){
                this.$router.push({ name: 'Region', params: { id: id } })
            },
            openMitgliederverwaltung(){
                this.$router.push('/')
            },
            openLiveSpiele(){
                this.$router.push('Ergebnisdienst/LiveSpiele')
            }
        },
    }
</script>

<style scoped>
    .impressum {text-decoration: none; color: white}
    .impressum:hover {color: #aaa}
    .lvBox {width: 160px}
    .headerBanner {width: 100%; height: 200px; background-position: center 15%; background-size: cover;
        background-repeat: no-repeat; margin: 0; position: relative;
        background-image: url("../../assets/header_classic.jpg");}
    .headerText { position: relative; top: 60px; font-size: 48px;
        font-weight: bold; text-align: center}
    .headerTextMob { position: relative; top: 72px; font-size: 36px;
        font-weight: bold; text-align: center}
    .flag {display: block; margin-left: auto; margin-right: auto;
        height: 96px; width: 96px; object-fit: cover;}
</style>